import { CourseType } from '../../../../../resources/@types/courseSchema';
import { CoursesSort } from './sort';

/**
 * @deprecated
 * @description
 * 레거시 쿼리 파라미터로 접근해도 정상 동작하도록 하기 위한 코드들
 * due=not_expired
 * progress=studying, completed
 * type=off, on
 * order=buy, title, study
 * s=${keyword}
 */
export function forLegacyParameter(queryObject: Record<string, string>) {
  const newQueryObject = {} as Record<string, string>;

  if (queryObject.due === 'not_expired') {
    newQueryObject.isExcludeExpired = 'true';
  }

  if (queryObject.progress) {
    newQueryObject.studying = 'true';
  }

  if (queryObject.type) {
    newQueryObject.courseType = queryObject.type === 'on' ? CourseType.ON : CourseType.OFF;
  }

  if (queryObject.order) {
    if (queryObject.order === 'buy') {
      newQueryObject.sort = CoursesSort.RECENT_APPLY;
    }

    if (queryObject.order === 'title') {
      newQueryObject.sort = CoursesSort.COURSE_TITLE;
    }

    if (queryObject.order === 'study') {
      newQueryObject.sort = CoursesSort.RECENT_STUDYING;
    }
  }

  if (queryObject.s) {
    newQueryObject.searchKeyword = queryObject.s;
  }

  if (queryObject.user_id) {
    newQueryObject.userId = queryObject.user_id;
  }

  return {
    ...queryObject,
    ...newQueryObject,
  };
}
